export class Franchise {
    constructor() {
        this.states = new Array<number>();
    }
    cityNames: string;
    hasRealEstateExperience?: boolean;
    realEstateExperienceDescription: string;
    hasFranchiseExperience?: boolean;
    franchiseExperienceDescription: string;
    hasOtherHoldings?: boolean;
    otherHoldingsDescription: string;
    numberOfRestaurantsValueId: number;
    investingOptionsValueId: number;
    investingOptionsDetails: string;
    liquidAssetsValueId: number;
    netWorthValueId: number;
    whyWhataburgerExplanation: string;
    states: number[];
    resumeReference: string;
}
